'use strict';

var jsxRuntime = require('react/jsx-runtime');
var react = require('react');
var InternalFlexBox = require('../../_chunks/InternalFlexBox-BDDWEQ9L.js');
require('../../_chunks/combineClasses-5P8GTQkg.js');
require('../../_chunks/index-CIVOGJRG.js');
require('../../_chunks/designTokens-CKP-YoT2.js');

const FlexBox = react.forwardRef(({ as = 'div', ...rest }, ref) => (jsxRuntime.jsx(InternalFlexBox.InternalFlexBox, { as: as, ref: ref, ...rest })));
FlexBox.displayName = 'FlexBox';

exports.FlexBox = FlexBox;
//# sourceMappingURL=FlexBox.js.map
